import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AdminApp from './admin/AdminApp';
import AudienceApp from './audience/AudienceApp';
import DisplayApp from './display/DisplayApp';
import MasterApp from './master/MasterApp';
import LandingPage from './LandingPage';

// Component to preserve query params during redirect
function JoinRedirect() {
  const location = useLocation();
  return <Navigate to={`/audience/join${location.search}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin interface - desktop application */}
        <Route path="/admin/*" element={<AdminApp />} />

        {/* Audience interface - mobile application */}
        <Route path="/audience/*" element={<AudienceApp />} />
        <Route path="/join" element={<JoinRedirect />} />

        {/* Display interface - projection screen */}
        <Route path="/display/*" element={<DisplayApp />} />

        {/* Master interface - all winners overview */}
        <Route path="/master/*" element={<MasterApp />} />

        {/* Landing page */}
        <Route path="/" element={<LandingPage />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
